/**
 * LCP (Largest Contentful Paint) Optimizer
 * Helps identify and optimize the LCP element
 */

(function() {
  'use strict';

  // Track LCP element
  let lcpElement = null;
  let lcpTime = 0;

  // Observe LCP candidates
  if ('PerformanceObserver' in window) {
    try {
      const lcpObserver = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        const lastEntry = entries[entries.length - 1];
        
        if (lastEntry && lastEntry.startTime > lcpTime) {
          lcpTime = lastEntry.startTime;
          lcpElement = lastEntry.element;
          
          // Optimize LCP element if it's an image
          if (lcpElement && lcpElement.tagName === 'IMG') {
            optimizeLCPImage(lcpElement);
          }
        }
      });

      lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });
    } catch (e) {
      // PerformanceObserver not supported or error
    }
  }

  function optimizeLCPImage(img) {
    // Ensure image has proper loading attributes
    if (!img.loading && img.src && !img.complete) {
      // If image is above the fold, ensure it's not lazy loaded
      const rect = img.getBoundingClientRect();
      if (rect.top < window.innerHeight * 2) {
        img.loading = 'eager';
        img.fetchPriority = 'high';
      }
    }
  }

  // Preload critical images
  function preloadCriticalImages() {
    // Find hero images or first large image
    const heroImages = document.querySelectorAll(
      'img[loading="eager"], img[fetchpriority="high"], .hero img, .banner img, .slideshow img:first-of-type'
    );

    heroImages.forEach(img => {
      if (img.src && !img.complete) {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = img.src;
        if (img.srcset) {
          link.imageSrcset = img.srcset;
          link.imageSizes = img.sizes || '';
        }
        document.head.appendChild(link);
      }
    });
  }

  // Run optimizations after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preloadCriticalImages);
  } else {
    preloadCriticalImages();
  }

  // Export for debugging
  window.LCPOptimizer = {
    getLCPElement: () => lcpElement,
    getLCPTime: () => lcpTime
  };
})();
